module.exports = __webpack_public_path__ + "a/static/img/tip_success.60a00c73.png";